import { connect } from 'react-redux';

import { verifyPaymentCallback, resetPage } from '../../actions/PaymentCallbackPage';
import PaymentCallbackPage from './PaymentCallbackPage';

const mapsStateToProps = state => ({
	paymentCallbackPageProps: state.paymentCallbackPageReducer
});

const mapsDispatchToProps = dispatch => ({
	verifyPaymentCallback(order_id, token) {
		dispatch(verifyPaymentCallback(order_id, token));
	},
	resetPage() {
		dispatch(resetPage());
	}
});

export default connect(
	mapsStateToProps,
	mapsDispatchToProps
)(PaymentCallbackPage);
